function initMenu() {
	const mainNav = document.getElementById("main-nav"),
		mainMenuToggler = document.getElementById("main-nav-toggler"),
		navbar = document.getElementById("smx-wrapper-navbar"),
		htmlTag = document.getElementsByTagName("html")[0];

	mainMenuToggler.addEventListener("click", () => {
		let isOpen = mainNav.classList.contains("open");
		if (isOpen) {
			mainMenuToggler.setAttribute("aria-expanded", "false");
			mainNav.classList.remove("open");
			htmlTag.classList.remove("no-scroll");
		} else {
			mainMenuToggler.setAttribute("aria-expanded", "true");
			mainNav.classList.add("open");
			htmlTag.classList.add("no-scroll");
		}
	});

	window.addEventListener("scroll", function () {
		var scrollTop = document.documentElement.scrollTop;
		if (scrollTop >= 150) {
			navbar.classList.add("scrolled");
		} else {
			navbar.classList.remove("scrolled");
		}
	});
}

export default { initMenu };
